<script>
import TaxReturnTableRow from "@/components/accountants/tax_return/table/TaxReturnTableRow.vue";
import TaxReturnTable from "@/components/accountants/tax_return/table/TaxReturnTable.vue";
import TaxReturnTableHeader from "@/components/accountants/tax_return/table/TaxReturnTableHeader.vue";

export default {
  name: "TaxReturnWorthChangeSection",
  components: {TaxReturnTableHeader, TaxReturnTable, TaxReturnTableRow},
  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>

<template>
  <TaxReturnTable>
    <template v-slot:header>
      <TaxReturnTableHeader/>
    </template>

    <template v-slot:body>
      <TaxReturnTableRow :description="$gettext('Overige waardeveranderingen van immateriele en materiele vaste activa')"
                         :calculated-value="data.calculated.statement_change_other"
                         v-model="data.edit.statement_change_other"/>

      <TaxReturnTableRow :description="$gettext('Bijzondere waardeveranderingen van vlottende activa')"
                         :calculated-value="data.calculated.statement_change_special"
                         v-model="data.edit.statement_change_special"/>
    </template>
  </TaxReturnTable>
</template>

<style scoped lang="scss">

</style>